import { useQuery } from "@tanstack/react-query";
import { getController } from "../../api/bIntegrationsApi";

export const useGetController = (organisationId, controllerName, type) => {
  return useQuery({
    queryKey: ["controller", organisationId, controllerName, type],
    queryFn: () => getController(organisationId, controllerName, type),
    enabled: !!organisationId && !!controllerName && !!type,
  });
};